/**
 * Removes an SVG element from a parent
 * @param parent Parent
 * @param queryOrExisting Query or existing element
 * @returns
 */
export const remove = (parent, queryOrExisting) => {
    if (typeof queryOrExisting === `string`) {
        const elem = parent.querySelector(queryOrExisting);
        if (elem === null)
            return;
        elem.remove();
    }
    else {
        queryOrExisting.remove();
    }
};
/**
 * Removes all children of `parent`, but not `parent` itself.
 * @param parent
 */
export const clear = (parent) => {
    let c = parent.lastElementChild;
    while (c) {
        c.remove();
        c = parent.lastElementChild;
    }
};
